import { FlowContainer as Flows } from './FlowContainer'

// eslint-disable-next-line import/no-default-export
export default Flows
